/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PreviewSurveyMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  description?: Types.InputMaybe<Types.Scalars['String']>;
  questionIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type PreviewSurveyMutation = { previewSurvey: string };


export const PreviewSurveyDocument = gql`
    mutation PreviewSurvey($name: String!, $description: String, $questionIds: [Int!]!) {
  previewSurvey(name: $name, description: $description, questionIds: $questionIds)
}
    `;

/**
 * __usePreviewSurveyMutation__
 *
 * To run a mutation, you first call `usePreviewSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewSurveyMutation, { data, loading, error }] = usePreviewSurveyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function usePreviewSurveyMutation(baseOptions?: Apollo.MutationHookOptions<PreviewSurveyMutation, PreviewSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewSurveyMutation, PreviewSurveyMutationVariables>(PreviewSurveyDocument, options);
      }
export type PreviewSurveyMutationHookResult = ReturnType<typeof usePreviewSurveyMutation>;
export type PreviewSurveyMutationResult = Apollo.MutationResult<PreviewSurveyMutation>;
export type PreviewSurveyMutationOptions = Apollo.BaseMutationOptions<PreviewSurveyMutation, PreviewSurveyMutationVariables>;